import translate from "@/utils/translate"
import { Link, router, usePage } from "@inertiajs/react"
import useConfirmation from '@/Admin/Components/ActionConfirmation/useConfirmation';
import ConfirmationModal from '@/Admin/Components/ActionConfirmation/ConfirmationModal';

export default function Sidebar() {
    const confirmLogout = useConfirmation();

    // handle logout
    const handleLogout = () => {
        confirmLogout.showConfirmation({
            title: `${translate("Are you sure")}`,
            message: `${translate("logout_session")}`,
            confirmText: `${translate("log_out")}!`,
            cancelText: translate("Cancel"),
            onConfirm: () => {
                router.post(route("logout"))
            },
            onCancel: () => {},
            onClose: () => {},
        });
    }

    return (
        <>
            <div className="cs_dashboard_left">
                <ul className="cs_dashboard_nav cs_mp0 cs_radius_5 cs_primary_color">
                    <li className={route().current("user.dashboard") ? "active" : ""}>
                        <Link href={route("user.dashboard")}>
                            <i className="fa-light fa-house"></i> {translate("Dashboard")}
                        </Link>
                    </li>
                    <li className={route().current("user.orders") ? "active" : ""}>
                        <Link href={route("user.orders")}>
                            <i className="fa-light fa-file-pen"></i> {translate("My Orders")}
                        </Link>
                    </li>
                    <li className={route().current("user.review.index") ? "active" : ""}>
                        <Link href={route("user.review.index")}>
                            <i className="fa-light fa-star"></i> {translate("Reviews")}
                        </Link>
                    </li>
                    <li className={route().current("user.tickets.create") ? "active" : ""}>
                        <Link href={route("user.tickets.create")}>
                            <i className="fa-light fa-headphones"></i> {translate("Open Ticket")}
                        </Link>
                    </li>
                    <li className={route().current("user.tickets.index") ? "active" : ""}>
                        <Link href={route("user.tickets.index")}>
                            <i className="fa-light fa-ticket"></i> {translate("Support Ticket")}
                        </Link>
                    </li>
                    <li className={route().current("user.profile.edit") ? "active" : ""}>
                        <Link href={route("user.profile.edit")}>
                            <i className="fa-light fa-gear"></i> {translate("Profile Settings")}
                        </Link>
                    </li>
                    <li className={route().current("user.profile.change.password") ? "active" : ""}>
                        <Link href={route("user.profile.change.password")}>
                            <i className="fa-light fa-lock"></i> {translate("Change Password")}
                        </Link>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                            <i className="fa-light fa-arrow-right-from-bracket"></i> {translate("log_out")}
                        </a>
                    </li>
                </ul>
            </div>

            <ConfirmationModal
                isOpen={confirmLogout.isOpen}
                title={confirmLogout.title}
                message={confirmLogout.message}
                confirmText={confirmLogout.confirmText}
                cancelText={confirmLogout.cancelText}
                onConfirm={confirmLogout.handleConfirm}
                onCancel={confirmLogout.handleCancel}
                onClose={confirmLogout.handleClose}
            />
        </>
    )
}